import { Component } from '@angular/core';
import { Storage } from '@ionic/storage';
import { NavController, ToastController, LoadingController } from 'ionic-angular';
import { UsuarioDAO } from '../../daos/usuario-dao';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Usuario } from '../../entities/usuario';
import { MenuComponent } from '../../components/menu/menu';

@Component({
    selector: 'page-login',
    templateUrl: './login.html'
})
export class LoginPage {
    public formLogin: FormGroup;
    public usuario: Usuario = new Usuario();

    constructor(
        private _formBuilder: FormBuilder,
        private _navCtrl: NavController,
        private _toastCtrl: ToastController,
        private _loadingCtrl: LoadingController,
        private _usuarioDao: UsuarioDAO,
        private _storage: Storage
    ) {
        this.manterLogin();
        this.formLogin = this._formBuilder.group({
            Usuario: ['', Validators.compose([Validators.required, Validators.minLength(4)])],
            Senha: ['', Validators.compose([Validators.required, Validators.minLength(4)])],
            MantenhaConectado: [false]
        });
           
        
        
        
    }

    manterLogin(): void {
        this._storage.get('manter').then(manter => {
            if (manter) {
                this._storage.get('usuario').then(usuario => {  
                    if (usuario !== null){
                        this.usuario = usuario;   
                        this._navCtrl.setRoot(MenuComponent, { usuario: usuario });
                    }  
                });
            } 
        });
    }

    public doLogin(): void {
        this.usuario.NomeUsuario = this.usuario.NomeUsuario.toLowerCase();
        this.usuario.Senha = this.usuario.Senha.toLowerCase();

        if (this.formLogin.invalid) {
            this._toastCtrl.create({
                message: 'O formulário está invalido. Favor Verifique!',
                duration: 3000
            }).present();

            return;
        }

        let load = this._loadingCtrl.create({ content: 'Autenticando o usuário...' });
        load.present();

        this._usuarioDao.login(this.usuario).then((usuario) => {
            if (usuario.Id)
                this._navCtrl.setRoot(MenuComponent, { usuario: usuario }).then(() => {
                    load.dismiss();
                    this._storage.set('manter', (this.formLogin.controls['MantenhaConectado'].value));
                    if (this.formLogin.controls['MantenhaConectado'].value)
                        this._storage.set('usuario', usuario);
                });
            else
                load.dismiss().then(() => {
                    this._toastCtrl.create({
                        message: 'Usuário inválido!',
                        duration: 3000
                    }).present();
                });
        }).catch((erro) => {
            console.error(erro);
            load.dismiss();
            this._toastCtrl.create({
                message: 'Não foi possível entrar, tente novamente!',
                duration: 3000
            }).present();
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts